"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonRichText = require("@mmc/common-rich-text");
var _commonCta = require("@mmc/common-cta");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _shouldRender = _interopRequireDefault(require("../utils/shouldRender"));
var _footerBottom = _interopRequireDefault(require("../styles/footer-bottom.css"));
var _footer = require("./footer.propTypes");
var _cookieSettings = _interopRequireDefault(require("./cookie-settings"));
var _CookieSettings, _img;
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var renderMarketLinks = function renderMarketLinks(hasMultipleLanguages, theme, expandCountryModal, changeCountryLabel) {
  var columnClasses = hasMultipleLanguages ? theme['col-xs-6'] + " " + theme['col-sm-4'] + " " + theme['col-sm-offset-1'] + " " + theme['col-lg-2'] : theme['col-xs-12'] + " " + theme['col-sm-10'] + " " + theme['col-sm-offset-1'];
  var ctaData = {
    label: changeCountryLabel,
    priority: 'low'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(columnClasses, _footerBottom["default"].dark)
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: ctaData,
    classes: [_footerBottom["default"].countryDropdownLink, _footerBottom["default"].mmcIconWorld, theme.lowIcon],
    clickEvent: expandCountryModal
  }));
};
var renderLanguages = function renderLanguages(languages, hasMarketLinks, theme) {
  var columnClasses = hasMarketLinks ? theme['col-xs-6'] + " " + theme['col-lg-8'] : theme['col-xs-12'] + " " + theme['col-sm-10'] + " " + theme['col-sm-offset-1'];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: columnClasses
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _clsx["default"])(_footerBottom["default"].languagesList, theme.marginBottom20)
  }, languages.sort(function (x, y) {
    return y.selected - x.selected;
  }).map(function (language, i) {
    var itemKey = "" + language + i;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: _footerBottom["default"].languagesListItem,
      key: itemKey
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: language.selected ? _footerBottom["default"].languagesDesktopSelected : _footerBottom["default"].languagesDesktop,
      href: "/" + handleNestedProp(language, 'language.acronym')
    }, handleNestedProp(language, 'language.fullName')), /*#__PURE__*/_react["default"].createElement("a", {
      className: language.selected ? _footerBottom["default"].languagesMobileSelected : _footerBottom["default"].languagesMobile,
      href: "/" + handleNestedProp(language, 'language.acronym')
    }, handleNestedProp(language, 'language.acronym')));
  })));
};
var FooterBottom = function FooterBottom(_ref) {
  var theme = _ref.theme,
    links = _ref.links,
    languages = _ref.languages,
    copyRight = _ref.copyRight,
    hasMarketLinks = _ref.hasMarketLinks,
    expandCountryModal = _ref.expandCountryModal,
    changeCountryLabel = _ref.changeCountryLabel,
    market = _ref.market;
  var hasMultipleLanguages = languages && languages.length > 1;
  var isKW = market === 'kw';
  var renderLinks = function renderLinks(footerLinks) {
    return footerLinks.map(function (_ref2, i) {
      var url = _ref2.url,
        label = _ref2.label,
        openNewTab = _ref2.openNewTab;
      var itemKey = "" + url + i;
      return label === 'Configuración de cookies' ? _CookieSettings || (_CookieSettings = /*#__PURE__*/_react["default"].createElement(_cookieSettings["default"], null)) : /*#__PURE__*/_react["default"].createElement("li", {
        className: _footerBottom["default"].listItem,
        key: itemKey
      }, /*#__PURE__*/_react["default"].createElement("a", {
        target: "" + (openNewTab === true ? '_blank' : ''),
        href: url,
        className: _footerBottom["default"].link
      }, (0, _shouldRender["default"])(label)));
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _footerBottom["default"].footerBottom
  }, hasMarketLinks && renderMarketLinks(hasMultipleLanguages, theme, expandCountryModal, changeCountryLabel), hasMultipleLanguages && renderLanguages(languages, hasMarketLinks, theme), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-6'], theme.marginBottom40, theme['col-sm-offset-1'])
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: _footerBottom["default"].list
  }, renderLinks(links))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-4'], _footerBottom["default"].copyRight, theme.marginBottom40)
  }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
    theme: theme,
    html: copyRight,
    format: "legal",
    tagName: "p"
  })), isKW && /*#__PURE__*/_react["default"].createElement("div", {
    className: _footerBottom["default"].whatsAppWebChatBubbleContainer
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwa.me%2f96522055888%3ftext%3dhi&c=E,1,_H10vyeRCF2wAafG9xwDFt1zt42hvESLhMSvUgBJTHmcAIkIZRMywumA1Ui92zmbsdqjgz0C2kZDxvqiasIFJXzGyZoj0zTDU6qD3PSf2IJy5gIe081grEOGtSk,&typo=1",
    className: _footerBottom["default"].whatsAppWebChatImage
  }, _img || (_img = /*#__PURE__*/_react["default"].createElement("img", {
    border: "0",
    alt: "WhatsAppLogo",
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/479px-WhatsApp.svg.png"
  })))), ";");
};
var _default = FooterBottom;
exports["default"] = _default;